import { useAuth } from '@clerk/react';
import { useSetAtom } from 'jotai';
import { useEffect, useRef } from 'react';
import { consultantAccessNoticeRequestedAtAtom } from '../../stores/consultant-access-notice.store';

/**
 * The consultant-access notice belongs to one signed-in user. Without this
 * reset, signing out and in as someone else in the same tab would inherit the
 * previous user's notice until a refetch lands. Clerk reports `undefined` while
 * loading and `null` signed out.
 */
export function useResetConsultantAccessOnUserChange() {
  const { userId } = useAuth();
  const setNoticeRequestedAt = useSetAtom(consultantAccessNoticeRequestedAtAtom);
  const previousUserIdRef = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    if (userId === undefined) {
      return;
    }
    const previousUserId = previousUserIdRef.current;
    previousUserIdRef.current = userId;
    if (previousUserId === undefined || previousUserId === userId) {
      return;
    }
    setNoticeRequestedAt(null);
  }, [userId, setNoticeRequestedAt]);
}
